import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Labels } from '@core/constants/labels';
import { ExamRequest } from '@core/models/exam-request.model';

@Component({
  selector: 'app-exam-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './exam-card.component.html',
  styleUrl: './exam-card.component.scss',
})
export class ExamCardComponent {
  labels = Labels.PATIENT_CARD;

  @Input() exam: ExamRequest | null = null;
  @Input() status: string = '';
  @Input() urgent: boolean = false;
  @Input() nonReads: number = 0;

  @Output() clicked = new EventEmitter<ExamRequest>();

  handleClick(): void {
    if (this.exam !== null) {
      this.clicked.emit(this.exam);
    }
  }
}
